function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e7) { throw _e7; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e8) { didErr = true; err = _e8; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/**
 * React Router DOM v6.11.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? t(exports, require("react"), require("react-router"), require("@remix-run/router")) : "function" == typeof define && define.amd ? define(["exports", "react", "react-router", "@remix-run/router"], t) : t((e = "undefined" != typeof globalThis ? globalThis : e || self).ReactRouterDOM = {}, e.React, e.ReactRouter, e.RemixRouter);
}(this, function (e, t, r, n) {
  "use strict";

  function o(e) {
    if (e && e.__esModule) return e;
    var t = Object.create(null);
    return e && Object.keys(e).forEach(function (r) {
      if ("default" !== r) {
        var n = Object.getOwnPropertyDescriptor(e, r);
        Object.defineProperty(t, r, n.get ? n : {
          enumerable: !0,
          get: function get() {
            return e[r];
          }
        });
      }
    }), t.default = e, Object.freeze(t);
  }
  var a = o(t);
  function u() {
    return u = Object.assign ? Object.assign.bind() : function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, u.apply(this, arguments);
  }
  function i(e, t) {
    if (null == e) return {};
    var r,
      n,
      o = {},
      a = Object.keys(e);
    for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
    return o;
  }
  var c = "get",
    s = "application/x-www-form-urlencoded";
  function l(e) {
    return null != e && "string" == typeof e.tagName;
  }
  function f(e) {
    return void 0 === e && (e = ""), new URLSearchParams("string" == typeof e || Array.isArray(e) || e instanceof URLSearchParams ? e : Object.keys(e).reduce(function (t, r) {
      var n = e[r];
      return t.concat(Array.isArray(n) ? n.map(function (e) {
        return [r, e];
      }) : [[r, n]]);
    }, []));
  }
  function d(e, t, r) {
    var o,
      a,
      u,
      i = null;
    if (l(f = e) && "form" === f.tagName.toLowerCase()) {
      var _l = t.submissionTrigger;
      if (t.action) i = t.action;else {
        var _t = e.getAttribute("action");
        i = _t ? n.stripBasename(_t, r) : null;
      }
      o = t.method || e.getAttribute("method") || c, a = t.encType || e.getAttribute("enctype") || s, u = new FormData(e), _l && _l.name && u.append(_l.name, _l.value);
    } else if (function (e) {
      return l(e) && "button" === e.tagName.toLowerCase();
    }(e) || function (e) {
      return l(e) && "input" === e.tagName.toLowerCase();
    }(e) && ("submit" === e.type || "image" === e.type)) {
      var _l2 = e.form;
      if (null == _l2) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
      if (t.action) i = t.action;else {
        var _t2 = e.getAttribute("formaction") || _l2.getAttribute("action");
        i = _t2 ? n.stripBasename(_t2, r) : null;
      }
      o = t.method || e.getAttribute("formmethod") || _l2.getAttribute("method") || c, a = t.encType || e.getAttribute("formenctype") || _l2.getAttribute("enctype") || s, u = new FormData(_l2), e.name && u.append(e.name, e.value);
    } else {
      if (l(e)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
      if (o = t.method || c, i = t.action || null, a = t.encType || s, e instanceof FormData) u = e;else if (u = new FormData(), e instanceof URLSearchParams) {
        var _iterator = _createForOfIteratorHelper(e),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _ref = _step.value;
            var _ref2 = _slicedToArray(_ref, 2);
            var _t3 = _ref2[0];
            var _r = _ref2[1];
            u.append(_t3, _r);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else if (null != e) for (var _i = 0, _Object$keys = Object.keys(e); _i < _Object$keys.length; _i++) {
        var _t4 = _Object$keys[_i];
        u.append(_t4, e[_t4]);
      }
    }
    var f;
    return {
      action: i,
      method: o.toLowerCase(),
      encType: a,
      formData: u
    };
  }
  var m = ["onClick", "relative", "reloadDocument", "replace", "state", "target", "to", "preventScrollReset"],
    p = ["aria-current", "caseSensitive", "className", "end", "style", "to", "children"],
    b = ["reloadDocument", "replace", "method", "action", "onSubmit", "fetcherKey", "routeId", "relative", "preventScrollReset"];
  function g() {
    var e;
    var t = null == (e = window) ? void 0 : e.__staticRouterHydrationData;
    return t && t.errors && (t = u({}, t, {
      errors: h(t.errors)
    })), t;
  }
  function h(e) {
    if (!e) return null;
    var t = Object.entries(e),
      r = {};
    for (var _i2 = 0, _t5 = t; _i2 < _t5.length; _i2++) {
      var _ref3 = _t5[_i2];
      var _ref4 = _slicedToArray(_ref3, 2);
      var _e = _ref4[0];
      var _o = _ref4[1];
      if (_o && "RouteErrorResponse" === _o.__type) r[_e] = new n.ErrorResponse(_o.status, _o.statusText, _o.data, !0 === _o.internal);else if (_o && "Error" === _o.__type) {
        var _t6 = new Error(_o.message);
        _t6.stack = "", r[_e] = _t6;
      } else r[_e] = _o;
    }
    return r;
  }
  var y = "undefined" != typeof window && void 0 !== window.document && void 0 !== window.document.createElement,
    v = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i,
    R = a.forwardRef(function (e, t) {
      var o,
        c = e.onClick,
        s = e.relative,
        l = e.reloadDocument,
        f = e.replace,
        d = e.state,
        p = e.target,
        b = e.to,
        g = e.preventScrollReset,
        h = i(e, m),
        _a$useContext = a.useContext(r.UNSAFE_NavigationContext),
        R = _a$useContext.basename,
        w = !1;
      if ("string" == typeof b && v.test(b) && (o = b, y)) try {
        var _e2 = new URL(window.location.href),
          _t7 = b.startsWith("//") ? new URL(_e2.protocol + b) : new URL(b),
          _r2 = n.stripBasename(_t7.pathname, R);
        _t7.origin === _e2.origin && null != _r2 ? b = _r2 + _t7.search + _t7.hash : w = !0;
      } catch (e) {}
      var P = r.useHref(b, {
          relative: s
        }),
        S = N(b, {
          replace: f,
          state: d,
          target: p,
          preventScrollReset: g,
          relative: s
        });
      return a.createElement("a", u({}, h, {
        href: o || P,
        onClick: w || l ? c : function (e) {
          c && c(e), e.defaultPrevented || S(e);
        },
        ref: t,
        target: p
      }));
    }),
    w = a.forwardRef(function (e, t) {
      var _e$ariaCurrent = e["aria-current"],
        n = _e$ariaCurrent === void 0 ? "page" : _e$ariaCurrent,
        _e$caseSensitive = e.caseSensitive,
        o = _e$caseSensitive === void 0 ? !1 : _e$caseSensitive,
        _e$className = e.className,
        c = _e$className === void 0 ? "" : _e$className,
        _e$end = e.end,
        s = _e$end === void 0 ? !1 : _e$end,
        l = e.style,
        f = e.to,
        d = e.children,
        m = i(e, p),
        b = r.useResolvedPath(f, {
          relative: m.relative
        }),
        g = r.useLocation(),
        h = a.useContext(r.UNSAFE_DataRouterStateContext),
        _a$useContext2 = a.useContext(r.UNSAFE_NavigationContext),
        y = _a$useContext2.navigator,
        v = y.encodeLocation ? y.encodeLocation(b).pathname : b.pathname,
        w = g.pathname,
        P = h && h.navigation && h.navigation.location ? h.navigation.location.pathname : null;
      o || (w = w.toLowerCase(), P = P ? P.toLowerCase() : null, v = v.toLowerCase());
      var S,
        E = w === v || !s && w.startsWith(v) && "/" === w.charAt(v.length),
        O = null != P && (P === v || !s && P.startsWith(v) && "/" === P.charAt(v.length)),
        j = E ? n : void 0;
      S = "function" == typeof c ? c({
        isActive: E,
        isPending: O
      }) : [c, E ? "active" : null, O ? "pending" : null].filter(Boolean).join(" ");
      var A = "function" == typeof l ? l({
        isActive: E,
        isPending: O
      }) : l;
      return a.createElement(R, u({}, m, {
        "aria-current": j,
        className: S,
        ref: t,
        style: A,
        to: f
      }), "function" == typeof d ? d({
        isActive: E,
        isPending: O
      }) : d);
    }),
    P = a.forwardRef(function (e, t) {
      return a.createElement(S, u({}, e, {
        ref: t
      }));
    }),
    S = a.forwardRef(function (e, t) {
      var r = e.reloadDocument,
        n = e.replace,
        _e$method = e.method,
        o = _e$method === void 0 ? c : _e$method,
        s = e.action,
        l = e.onSubmit,
        f = e.fetcherKey,
        d = e.routeId,
        m = e.relative,
        p = e.preventScrollReset,
        g = i(e, b),
        h = F(f, d),
        y = "get" === o.toLowerCase() ? "get" : "post",
        v = C(s, {
          relative: m
        });
      return a.createElement("form", u({
        ref: t,
        method: y,
        action: v,
        onSubmit: r ? l : function (e) {
          if (l && l(e), e.defaultPrevented) return;
          e.preventDefault();
          var t = e.nativeEvent.submitter,
            r = (null == t ? void 0 : t.getAttribute("formmethod")) || o;
          h(t || e.currentTarget, {
            method: r,
            replace: n,
            relative: m,
            preventScrollReset: p
          });
        }
      }, g));
    });
  var E, O;
  function j(e) {
    var t = a.useContext(r.UNSAFE_DataRouterContext);
    return t || n.UNSAFE_invariant(!1), t;
  }
  function A(e) {
    var t = a.useContext(r.UNSAFE_DataRouterStateContext);
    return t || n.UNSAFE_invariant(!1), t;
  }
  function N(e, t) {
    var _ref5 = void 0 === t ? {} : t,
      n = _ref5.target,
      o = _ref5.replace,
      u = _ref5.state,
      i = _ref5.preventScrollReset,
      c = _ref5.relative,
      s = r.useNavigate(),
      l = r.useLocation(),
      f = r.useResolvedPath(e, {
        relative: c
      });
    return a.useCallback(function (t) {
      if (function (e, t) {
        return !(0 !== e.button || t && "_self" !== t || function (e) {
          return !!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
        }(e));
      }(t, n)) {
        t.preventDefault();
        var _n = void 0 !== o ? o : r.createPath(l) === r.createPath(f);
        s(e, {
          replace: _n,
          state: u,
          preventScrollReset: i,
          relative: c
        });
      }
    }, [l, s, f, o, u, n, e, i, c]);
  }
  function F(e, t) {
    var _j = j(E.UseSubmitImpl),
      o = _j.router,
      _a$useContext3 = a.useContext(r.UNSAFE_NavigationContext),
      i = _a$useContext3.basename,
      c = r.UNSAFE_useRouteId();
    return a.useCallback(function (r, a) {
      if (void 0 === a && (a = {}), "undefined" == typeof document) throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
      var _d = d(r, a, i),
        s = _d.action,
        l = _d.method,
        f = _d.encType,
        m = _d.formData,
        p = {
          preventScrollReset: a.preventScrollReset,
          formData: m,
          formMethod: l,
          formEncType: f
        };
      e ? (null == t && n.UNSAFE_invariant(!1), o.fetch(e, t, s, p)) : o.navigate(s, u({}, p, {
        replace: a.replace,
        fromRouteId: c
      }));
    }, [o, i, e, t, c]);
  }
  function C(e, t) {
    var _ref6 = void 0 === t ? {} : t,
      o = _ref6.relative,
      _a$useContext4 = a.useContext(r.UNSAFE_NavigationContext),
      i = _a$useContext4.basename,
      c = a.useContext(r.UNSAFE_RouteContext);
    c || n.UNSAFE_invariant(!1);
    var _c$matches$slice = c.matches.slice(-1),
      _c$matches$slice2 = _slicedToArray(_c$matches$slice, 1),
      s = _c$matches$slice2[0],
      l = u({}, r.useResolvedPath(e || ".", {
        relative: o
      })),
      f = r.useLocation();
    if (null == e && (l.search = f.search, l.hash = f.hash, s.route.index)) {
      var _e3 = new URLSearchParams(l.search);
      _e3.delete("index"), l.search = _e3.toString() ? "?" + _e3.toString() : "";
    }
    return e && "." !== e || !s.route.index || (l.search = l.search ? l.search.replace(/^\?/, "?index&") : "?index"), "/" !== i && (l.pathname = "/" === l.pathname ? i : n.joinPaths([i, l.pathname])), r.createPath(l);
  }
  !function (e) {
    e.UseScrollRestoration = "useScrollRestoration", e.UseSubmitImpl = "useSubmitImpl", e.UseFetcher = "useFetcher";
  }(E || (E = {})), function (e) {
    e.UseFetchers = "useFetchers", e.UseScrollRestoration = "useScrollRestoration";
  }(O || (O = {}));
  var U = 0;
  var _ = "react-router-scroll-positions";
  var x = {};
  function L(e) {
    var _ref7 = void 0 === e ? {} : e,
      t = _ref7.getKey,
      n = _ref7.storageKey,
      _j2 = j(E.UseScrollRestoration),
      o = _j2.router,
      _A = A(O.UseScrollRestoration),
      u = _A.restoreScrollPosition,
      i = _A.preventScrollReset,
      c = r.useLocation(),
      s = r.useMatches(),
      l = r.useNavigation();
    a.useEffect(function () {
      return window.history.scrollRestoration = "manual", function () {
        window.history.scrollRestoration = "auto";
      };
    }, []), function (e, t) {
      var _ref8 = t || {},
        r = _ref8.capture;
      a.useEffect(function () {
        var t = null != r ? {
          capture: r
        } : void 0;
        return window.addEventListener("pagehide", e, t), function () {
          window.removeEventListener("pagehide", e, t);
        };
      }, [e, r]);
    }(a.useCallback(function () {
      if ("idle" === l.state) {
        var _e4 = (t ? t(c, s) : null) || c.key;
        x[_e4] = window.scrollY;
      }
      sessionStorage.setItem(n || _, JSON.stringify(x)), window.history.scrollRestoration = "auto";
    }, [n, t, l.state, c, s])), "undefined" != typeof document && (a.useLayoutEffect(function () {
      try {
        var _e5 = sessionStorage.getItem(n || _);
        _e5 && (x = JSON.parse(_e5));
      } catch (e) {}
    }, [n]), a.useLayoutEffect(function () {
      var e = null == o ? void 0 : o.enableScrollRestoration(x, function () {
        return window.scrollY;
      }, t);
      return function () {
        return e && e();
      };
    }, [o, t]), a.useLayoutEffect(function () {
      if (!1 !== u) if ("number" != typeof u) {
        if (c.hash) {
          var _e6 = document.getElementById(c.hash.slice(1));
          if (_e6) return void _e6.scrollIntoView();
        }
        !0 !== i && window.scrollTo(0, 0);
      } else window.scrollTo(0, u);
    }, [c, u, i]));
  }
  Object.defineProperty(e, "AbortedDeferredError", {
    enumerable: !0,
    get: function get() {
      return r.AbortedDeferredError;
    }
  }), Object.defineProperty(e, "Await", {
    enumerable: !0,
    get: function get() {
      return r.Await;
    }
  }), Object.defineProperty(e, "MemoryRouter", {
    enumerable: !0,
    get: function get() {
      return r.MemoryRouter;
    }
  }), Object.defineProperty(e, "Navigate", {
    enumerable: !0,
    get: function get() {
      return r.Navigate;
    }
  }), Object.defineProperty(e, "NavigationType", {
    enumerable: !0,
    get: function get() {
      return r.NavigationType;
    }
  }), Object.defineProperty(e, "Outlet", {
    enumerable: !0,
    get: function get() {
      return r.Outlet;
    }
  }), Object.defineProperty(e, "Route", {
    enumerable: !0,
    get: function get() {
      return r.Route;
    }
  }), Object.defineProperty(e, "Router", {
    enumerable: !0,
    get: function get() {
      return r.Router;
    }
  }), Object.defineProperty(e, "RouterProvider", {
    enumerable: !0,
    get: function get() {
      return r.RouterProvider;
    }
  }), Object.defineProperty(e, "Routes", {
    enumerable: !0,
    get: function get() {
      return r.Routes;
    }
  }), Object.defineProperty(e, "UNSAFE_DataRouterContext", {
    enumerable: !0,
    get: function get() {
      return r.UNSAFE_DataRouterContext;
    }
  }), Object.defineProperty(e, "UNSAFE_DataRouterStateContext", {
    enumerable: !0,
    get: function get() {
      return r.UNSAFE_DataRouterStateContext;
    }
  }), Object.defineProperty(e, "UNSAFE_LocationContext", {
    enumerable: !0,
    get: function get() {
      return r.UNSAFE_LocationContext;
    }
  }), Object.defineProperty(e, "UNSAFE_NavigationContext", {
    enumerable: !0,
    get: function get() {
      return r.UNSAFE_NavigationContext;
    }
  }), Object.defineProperty(e, "UNSAFE_RouteContext", {
    enumerable: !0,
    get: function get() {
      return r.UNSAFE_RouteContext;
    }
  }), Object.defineProperty(e, "UNSAFE_useRouteId", {
    enumerable: !0,
    get: function get() {
      return r.UNSAFE_useRouteId;
    }
  }), Object.defineProperty(e, "createMemoryRouter", {
    enumerable: !0,
    get: function get() {
      return r.createMemoryRouter;
    }
  }), Object.defineProperty(e, "createPath", {
    enumerable: !0,
    get: function get() {
      return r.createPath;
    }
  }), Object.defineProperty(e, "createRoutesFromChildren", {
    enumerable: !0,
    get: function get() {
      return r.createRoutesFromChildren;
    }
  }), Object.defineProperty(e, "createRoutesFromElements", {
    enumerable: !0,
    get: function get() {
      return r.createRoutesFromElements;
    }
  }), Object.defineProperty(e, "defer", {
    enumerable: !0,
    get: function get() {
      return r.defer;
    }
  }), Object.defineProperty(e, "generatePath", {
    enumerable: !0,
    get: function get() {
      return r.generatePath;
    }
  }), Object.defineProperty(e, "isRouteErrorResponse", {
    enumerable: !0,
    get: function get() {
      return r.isRouteErrorResponse;
    }
  }), Object.defineProperty(e, "json", {
    enumerable: !0,
    get: function get() {
      return r.json;
    }
  }), Object.defineProperty(e, "matchPath", {
    enumerable: !0,
    get: function get() {
      return r.matchPath;
    }
  }), Object.defineProperty(e, "matchRoutes", {
    enumerable: !0,
    get: function get() {
      return r.matchRoutes;
    }
  }), Object.defineProperty(e, "parsePath", {
    enumerable: !0,
    get: function get() {
      return r.parsePath;
    }
  }), Object.defineProperty(e, "redirect", {
    enumerable: !0,
    get: function get() {
      return r.redirect;
    }
  }), Object.defineProperty(e, "renderMatches", {
    enumerable: !0,
    get: function get() {
      return r.renderMatches;
    }
  }), Object.defineProperty(e, "resolvePath", {
    enumerable: !0,
    get: function get() {
      return r.resolvePath;
    }
  }), Object.defineProperty(e, "unstable_useBlocker", {
    enumerable: !0,
    get: function get() {
      return r.unstable_useBlocker;
    }
  }), Object.defineProperty(e, "useActionData", {
    enumerable: !0,
    get: function get() {
      return r.useActionData;
    }
  }), Object.defineProperty(e, "useAsyncError", {
    enumerable: !0,
    get: function get() {
      return r.useAsyncError;
    }
  }), Object.defineProperty(e, "useAsyncValue", {
    enumerable: !0,
    get: function get() {
      return r.useAsyncValue;
    }
  }), Object.defineProperty(e, "useHref", {
    enumerable: !0,
    get: function get() {
      return r.useHref;
    }
  }), Object.defineProperty(e, "useInRouterContext", {
    enumerable: !0,
    get: function get() {
      return r.useInRouterContext;
    }
  }), Object.defineProperty(e, "useLoaderData", {
    enumerable: !0,
    get: function get() {
      return r.useLoaderData;
    }
  }), Object.defineProperty(e, "useLocation", {
    enumerable: !0,
    get: function get() {
      return r.useLocation;
    }
  }), Object.defineProperty(e, "useMatch", {
    enumerable: !0,
    get: function get() {
      return r.useMatch;
    }
  }), Object.defineProperty(e, "useMatches", {
    enumerable: !0,
    get: function get() {
      return r.useMatches;
    }
  }), Object.defineProperty(e, "useNavigate", {
    enumerable: !0,
    get: function get() {
      return r.useNavigate;
    }
  }), Object.defineProperty(e, "useNavigation", {
    enumerable: !0,
    get: function get() {
      return r.useNavigation;
    }
  }), Object.defineProperty(e, "useNavigationType", {
    enumerable: !0,
    get: function get() {
      return r.useNavigationType;
    }
  }), Object.defineProperty(e, "useOutlet", {
    enumerable: !0,
    get: function get() {
      return r.useOutlet;
    }
  }), Object.defineProperty(e, "useOutletContext", {
    enumerable: !0,
    get: function get() {
      return r.useOutletContext;
    }
  }), Object.defineProperty(e, "useParams", {
    enumerable: !0,
    get: function get() {
      return r.useParams;
    }
  }), Object.defineProperty(e, "useResolvedPath", {
    enumerable: !0,
    get: function get() {
      return r.useResolvedPath;
    }
  }), Object.defineProperty(e, "useRevalidator", {
    enumerable: !0,
    get: function get() {
      return r.useRevalidator;
    }
  }), Object.defineProperty(e, "useRouteError", {
    enumerable: !0,
    get: function get() {
      return r.useRouteError;
    }
  }), Object.defineProperty(e, "useRouteLoaderData", {
    enumerable: !0,
    get: function get() {
      return r.useRouteLoaderData;
    }
  }), Object.defineProperty(e, "useRoutes", {
    enumerable: !0,
    get: function get() {
      return r.useRoutes;
    }
  }), e.BrowserRouter = function (e) {
    var t = e.basename,
      o = e.children,
      u = e.window,
      i = a.useRef();
    null == i.current && (i.current = n.createBrowserHistory({
      window: u,
      v5Compat: !0
    }));
    var c = i.current,
      _a$useState = a.useState({
        action: c.action,
        location: c.location
      }),
      _a$useState2 = _slicedToArray(_a$useState, 2),
      s = _a$useState2[0],
      l = _a$useState2[1];
    return a.useLayoutEffect(function () {
      return c.listen(l);
    }, [c]), a.createElement(r.Router, {
      basename: t,
      children: o,
      location: s.location,
      navigationType: s.action,
      navigator: c
    });
  }, e.Form = P, e.HashRouter = function (e) {
    var t = e.basename,
      o = e.children,
      u = e.window,
      i = a.useRef();
    null == i.current && (i.current = n.createHashHistory({
      window: u,
      v5Compat: !0
    }));
    var c = i.current,
      _a$useState3 = a.useState({
        action: c.action,
        location: c.location
      }),
      _a$useState4 = _slicedToArray(_a$useState3, 2),
      s = _a$useState4[0],
      l = _a$useState4[1];
    return a.useLayoutEffect(function () {
      return c.listen(l);
    }, [c]), a.createElement(r.Router, {
      basename: t,
      children: o,
      location: s.location,
      navigationType: s.action,
      navigator: c
    });
  }, e.Link = R, e.NavLink = w, e.ScrollRestoration = function (e) {
    var t = e.getKey,
      r = e.storageKey;
    return L({
      getKey: t,
      storageKey: r
    }), null;
  }, e.UNSAFE_useScrollRestoration = L, e.createBrowserRouter = function (e, t) {
    return n.createRouter({
      basename: null == t ? void 0 : t.basename,
      future: u({}, null == t ? void 0 : t.future, {
        v7_prependBasename: !0
      }),
      history: n.createBrowserHistory({
        window: null == t ? void 0 : t.window
      }),
      hydrationData: (null == t ? void 0 : t.hydrationData) || g(),
      routes: e,
      mapRouteProperties: r.UNSAFE_mapRouteProperties
    }).initialize();
  }, e.createHashRouter = function (e, t) {
    return n.createRouter({
      basename: null == t ? void 0 : t.basename,
      future: u({}, null == t ? void 0 : t.future, {
        v7_prependBasename: !0
      }),
      history: n.createHashHistory({
        window: null == t ? void 0 : t.window
      }),
      hydrationData: (null == t ? void 0 : t.hydrationData) || g(),
      routes: e,
      mapRouteProperties: r.UNSAFE_mapRouteProperties
    }).initialize();
  }, e.createSearchParams = f, e.unstable_HistoryRouter = function (e) {
    var t = e.basename,
      n = e.children,
      o = e.history;
    var _a$useState5 = a.useState({
        action: o.action,
        location: o.location
      }),
      _a$useState6 = _slicedToArray(_a$useState5, 2),
      u = _a$useState6[0],
      i = _a$useState6[1];
    return a.useLayoutEffect(function () {
      return o.listen(i);
    }, [o]), a.createElement(r.Router, {
      basename: t,
      children: n,
      location: u.location,
      navigationType: u.action,
      navigator: o
    });
  }, e.unstable_usePrompt = function (e) {
    var t = e.when,
      n = e.message,
      o = r.unstable_useBlocker(t);
    a.useEffect(function () {
      "blocked" !== o.state || t || o.reset();
    }, [o, t]), a.useEffect(function () {
      if ("blocked" === o.state) {
        window.confirm(n) ? setTimeout(o.proceed, 0) : o.reset();
      }
    }, [o, n]);
  }, e.useBeforeUnload = function (e, t) {
    var _ref9 = t || {},
      r = _ref9.capture;
    a.useEffect(function () {
      var t = null != r ? {
        capture: r
      } : void 0;
      return window.addEventListener("beforeunload", e, t), function () {
        window.removeEventListener("beforeunload", e, t);
      };
    }, [e, r]);
  }, e.useFetcher = function () {
    var e;
    var _j3 = j(E.UseFetcher),
      t = _j3.router,
      o = a.useContext(r.UNSAFE_RouteContext);
    o || n.UNSAFE_invariant(!1);
    var i = null == (e = o.matches[o.matches.length - 1]) ? void 0 : e.route.id;
    null == i && n.UNSAFE_invariant(!1);
    var _a$useState7 = a.useState(function () {
        return String(++U);
      }),
      _a$useState8 = _slicedToArray(_a$useState7, 1),
      c = _a$useState8[0],
      _a$useState9 = a.useState(function () {
        return i || n.UNSAFE_invariant(!1), function (e, t) {
          return a.forwardRef(function (r, n) {
            return a.createElement(S, u({}, r, {
              ref: n,
              fetcherKey: e,
              routeId: t
            }));
          });
        }(c, i);
      }),
      _a$useState10 = _slicedToArray(_a$useState9, 1),
      s = _a$useState10[0],
      _a$useState11 = a.useState(function () {
        return function (e) {
          t || n.UNSAFE_invariant(!1), i || n.UNSAFE_invariant(!1), t.fetch(c, i, e);
        };
      }),
      _a$useState12 = _slicedToArray(_a$useState11, 1),
      l = _a$useState12[0],
      f = F(c, i),
      d = t.getFetcher(c),
      m = a.useMemo(function () {
        return u({
          Form: s,
          submit: f,
          load: l
        }, d);
      }, [d, s, f, l]);
    return a.useEffect(function () {
      return function () {
        t ? t.deleteFetcher(c) : console.warn("No router available to clean up from useFetcher()");
      };
    }, [t, c]), m;
  }, e.useFetchers = function () {
    return _toConsumableArray(A(O.UseFetchers).fetchers.values());
  }, e.useFormAction = C, e.useLinkClickHandler = N, e.useSearchParams = function (e) {
    var t = a.useRef(f(e)),
      n = a.useRef(!1),
      o = r.useLocation(),
      u = a.useMemo(function () {
        return function (e, t) {
          var r = f(e);
          if (t) {
            var _iterator2 = _createForOfIteratorHelper(t.keys()),
              _step2;
            try {
              var _loop = function _loop() {
                var e = _step2.value;
                r.has(e) || t.getAll(e).forEach(function (t) {
                  r.append(e, t);
                });
              };
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                _loop();
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }
          return r;
        }(o.search, n.current ? null : t.current);
      }, [o.search]),
      i = r.useNavigate(),
      c = a.useCallback(function (e, t) {
        var r = f("function" == typeof e ? e(u) : e);
        n.current = !0, i("?" + r, t);
      }, [i, u]);
    return [u, c];
  }, e.useSubmit = function () {
    return F();
  }, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});